{
  "id": "prometheus",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Prometeu",
    "en": "Prometheus"
  },
  "icon": "gods/prometheus",
  "portrait": "gods/prometheus-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "promethean": 1
  },
  "unlocks": ["promethean", "alluvial-clay", "heart-of-the-titans", "theft-of-fire"],
  "powers": ["valor"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml ClassicalAgePrometheus)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 promethean at the Temple (Kronos: +1 from KronosExtra*, so 2). God power Valor (cooldown 30 s)."
  }
}
